import { testDriveMember } from "../mockMembers";
import { mockPolicies } from "../mockPolicies";

import { MockPersona } from "./mockPersonas.types";

export const jakeFromStateFarm: MockPersona = {
  key: "jakeFromStateFarm",
  name: "Jake FromStateFarm",
  description: "🇺🇸 | State Farm policy | Hagerty login | No HDC | No Bills | MFA",
  partner: "state-farm",
  hasMfa: true,
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [],
      },
      policies: {
        usa: [mockPolicies["0193845SCP01-00"]],
        canada: [],
      },
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "jake@statefarm.com",
            firstName: "Jake",
            middleName: "",
            lastName: "FromStateFarm",
            mailingAddress: {
              line1: "One State Farm Plaza",
              line2: "",
              city: "Bloomington",
              state: "IL",
              postalCode: "61710",
              country: "USA",
            },
            preferredPhone: "3090248275",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: "STFRM",
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000011",
                source: "USA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "STFRM123",
                partnerId: "STFRM",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: testDriveMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [],
          outstandingBalance: 0,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
